import { useNavigate } from 'react-router-dom';

import { Chip, Icon, ListItemIcon, MenuItem, Typography } from '@/ui';

import type { FC } from 'react';

import { useMcpMemberFlag } from '@/hooks/useMcpMemberFlag';

interface McpAccountMenuItemsProps {
  onNavigate: () => void;
  variant: 'sidebar' | 'bottom';
}

const ENTRIES = [
  {
    icon: 'note',
    label: 'Coaching notes',
    route: '/m/settings/coaching-notes',
  },
  {
    icon: 'public_link',
    label: 'Connect your AI',
    route: '/m/settings/connect-ai',
  },
] as const;

const NewBadge = () => (
  <Chip
    className="ml-auto h-5 text-[11px] font-semibold"
    color="primary"
    label="New"
    size="small"
  />
);

const McpAccountMenuItems: FC<McpAccountMenuItemsProps> = ({
  onNavigate,
  variant,
}) => {
  const { enabled } = useMcpMemberFlag();
  const navigate = useNavigate();
  if (!enabled) {
    return null;
  }
  const go = (route: string) => {
    onNavigate();
    navigate(route);
  };
  return (
    <>
      {ENTRIES.map((entry) =>
        variant === 'sidebar' ? (
          <MenuItem
            key={entry.route}
            className="flex text-cement-500"
            onClick={() => go(entry.route)}
          >
            <ListItemIcon>
              <Icon className="text-cement-500">{entry.icon}</Icon>
            </ListItemIcon>
            <Typography variant="subtitle1">{entry.label}</Typography>
            <NewBadge />
          </MenuItem>
        ) : (
          <MenuItem
            key={entry.route}
            className="flex items-center justify-center text-cement-500"
            onClick={() => go(entry.route)}
          >
            <div className="flex flex-col items-center rounded-2xl p-2">
              <Icon>{entry.icon}</Icon>
              <Typography className="px-1 text-center" variant="subtitle2">
                {entry.label}
              </Typography>
              <NewBadge />
            </div>
          </MenuItem>
        ),
      )}
    </>
  );
};

export default McpAccountMenuItems;
